import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, ViewChild, HostListener, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from '@angular/cdk/text-field';
import { TextFieldModule } from '@angular/cdk/text-field';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["textArea"];
function TextAreaComponent_label_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function TextAreaComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, TextAreaComponent_label_1_span_2_Template, 2, 0, "span", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("label-disabled", ctx_r0.disabled)("read-only-label", ctx_r0.readonly);
    i0.ɵɵattribute("for", ctx_r0.id || ctx_r0.defaultId)("aria-label", ctx_r0.ariaLabel || null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.labelText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.required && !ctx_r0.disabled);
  }
}
function TextAreaComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.errorMessageText, " ");
  }
}
let inputTextCount = 0;
class TextAreaComponent {
  constructor(cdr, elementRef) {
    this.cdr = cdr;
    this.elementRef = elementRef;
    this.labelText = '';
    this.value = '';
    this.placeholder = '';
    this.disabled = false;
    this.readonly = false;
    this.errorState = false;
    this.autocomplete = 'off';
    this.id = '';
    this.resizeTextarea = false;
    this.fontSize = 'small';
    this.wrap = 'on';
    this.ariaLabel = '';
    this.ariaLabelledby = null;
    this.hideBorder = false;
    this.valueChange = new EventEmitter();
    this.numberOfLines = this.maxRows;
    /**
     * placeholder declarations. Replaced by the functions provided to `registerOnChange` and `registerOnTouched`
     */
    this.onChangeHandler = _ => {};
    this._onTouchedHandler = () => {};
    inputTextCount++;
    this.defaultId = `sol-text-area-${inputTextCount}`;
  }
  get textareaFontSizeClass() {
    return 'font-size-' + this.fontSize;
  }
  writeValue(value) {
    if (value) {
      this.value = value;
    } else {
      this.value = '';
    }
    this.cdr.markForCheck();
  }
  /**
   * Registers a listener that notifies the model when the control is blurred
   */
  registerOnTouched(fn) {
    this._onTouchedHandler = fn;
  }
  /**
   * Registers a listener that notifies the model when the control updates
   */
  registerOnChange(fn) {
    this.onChangeHandler = fn;
  }
  onChange(event) {
    event.stopPropagation();
  }
  /**
   * Listens for the host blurring, and notifies the model
   */
  focusOut() {
    this._onTouchedHandler();
  }
  getNumberOfLines(textarea) {
    const lineHeight = parseInt(window.getComputedStyle(textarea).getPropertyValue('line-height'), 10);
    const padding = parseInt(window.getComputedStyle(textarea).getPropertyValue('padding-top'), 10) + parseInt(window.getComputedStyle(textarea).getPropertyValue('padding-bottom'), 10);
    const viewableHeight = textarea.scrollHeight - padding;
    return Math.round(viewableHeight / lineHeight);
  }
  overflowOrHidden() {
    if (this.maxRows && this.numberOfLines) {
      return this.numberOfLines > this.maxRows ? false : true;
    }
    return true;
  }
  /**
   * Handles the input event from the `input`.
   * Sends events to the change handler and emits a value.
   */
  onInput(event) {
    const textarea = event.target;
    this.value = event.target.value;
    this.numberOfLines = this.getNumberOfLines(textarea);
    this.onChangeHandler(this.value);
    this.valueChange.emit(this.value);
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    if (this.textArea && this.textArea.nativeElement) {
      this.textArea.nativeElement.disabled = this.disabled;
    }
  }
  static {
    this.ɵfac = function TextAreaComponent_Factory(t) {
      return new (t || TextAreaComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TextAreaComponent,
      selectors: [["sol-text-area"]],
      viewQuery: function TextAreaComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textArea = _t.first);
        }
      },
      hostBindings: function TextAreaComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusout", function TextAreaComponent_focusout_HostBindingHandler() {
            return ctx.focusOut();
          });
        }
      },
      inputs: {
        labelText: "labelText",
        value: "value",
        placeholder: "placeholder",
        name: "name",
        disabled: "disabled",
        cols: "cols",
        required: "required",
        readonly: "readonly",
        minlength: "minlength",
        maxlength: "maxlength",
        minRows: "minRows",
        maxRows: "maxRows",
        errorMessageText: "errorMessageText",
        errorState: "errorState",
        autocomplete: "autocomplete",
        id: "id",
        resizeTextarea: "resizeTextarea",
        fontSize: "fontSize",
        wrap: "wrap",
        ariaLabel: [i0.ɵɵInputFlags.None, "aria-label", "ariaLabel"],
        ariaLabelledby: [i0.ɵɵInputFlags.None, "aria-labelledby", "ariaLabelledby"],
        hideBorder: "hideBorder"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: TextAreaComponent,
        multi: true
      }])],
      decls: 7,
      vars: 35,
      consts: [[1, "sol-text-area"], [3, "label-disabled", "read-only-label", 4, "ngIf"], [1, "sol-text-area-input", 3, "id", "value", "placeholder", "disabled", "readonly", "required", "cols", "cdkTextareaAutosize", "cdkAutosizeMinRows", "cdkAutosizeMaxRows", "autocomplete", "wrap", "input", "change"], ["autosize", "cdkTextareaAutosize", "textArea", ""], ["class", "error-message-container", 4, "ngIf"], ["class", "required-label", 4, "ngIf"], [1, "required-label"], [1, "error-message-container"], [1, "error-message"]],
      template: function TextAreaComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, TextAreaComponent_label_1_Template, 3, 8, "label", 1);
          i0.ɵɵelementStart(2, "textarea", 2, 3);
          i0.ɵɵlistener("input", function TextAreaComponent_Template_textarea_input_2_listener($event) {
            return ctx.onInput($event);
          })("change", function TextAreaComponent_Template_textarea_change_2_listener($event) {
            return ctx.onChange($event);
          });
          i0.ɵɵtext(5, "  ");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, TextAreaComponent_div_6_Template, 3, 1, "div", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.labelText);
          i0.ɵɵadvance();
          i0.ɵɵclassMap(ctx.textareaFontSizeClass);
          i0.ɵɵclassProp("error-border", ctx.errorMessageText || ctx.errorState)("read-only", ctx.readonly)("disabled", ctx.disabled)("resize-textarea", ctx.resizeTextarea)("wrap-off", ctx.wrap === "off")("hide-border", ctx.hideBorder)("hide-scroll", ctx.overflowOrHidden());
          i0.ɵɵproperty("id", ctx.id || ctx.defaultId)("value", ctx.value)("placeholder", ctx.placeholder)("disabled", ctx.disabled)("readonly", ctx.readonly)("required", ctx.required)("cols", ctx.cols)("cdkTextareaAutosize", !ctx.resizeTextarea)("cdkAutosizeMinRows", ctx.minRows)("cdkAutosizeMaxRows", ctx.maxRows)("autocomplete", ctx.autocomplete)("wrap", ctx.wrap);
          i0.ɵɵattribute("name", ctx.name)("name", ctx.name)("aria-labelledby", ctx.ariaLabelledby)("minLength", ctx.minlength)("maxLength", ctx.maxlength);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.errorMessageText);
        }
      },
      dependencies: [i1.CdkTextareaAutosize, i2.NgIf],
      styles: [".sol-text-area{display:block}.sol-text-area label{font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-size:var(--typography-opensans-body-overline-font-size);line-height:var(--typography-opensans-headline-h6-line-height);letter-spacing:var(--typography-opensans-body-overline-letter-spacing);display:flex;align-items:center;text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-interface-text700);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-stretch:var(--typography-opensans-body-overline-font-stretch);flex:none;order:0;flex-grow:0;margin-bottom:.25rem}.sol-text-area label .required-label{color:var(--color-button-destructive-hover);padding-left:.25rem}.sol-text-area .read-only-label{color:var(--color-interface-text800)}.sol-text-area .label-disabled{color:var(--color-globalstate-disabled-content)}.sol-text-area .sol-text-area-input{display:flex;padding:.5rem;border-radius:var(--radii-small-allcorners);border:.0625rem solid var(--global-state-inactive-border, #afc1ce);background:#fff;font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch);text-decoration:var(--typography-opensans-body-body3-text-decoration);color:var(--global-state-active-content);outline:none;box-sizing:content-box;max-width:calc(100% - 1.125rem)}.sol-text-area .sol-text-area-input:hover{border:.0625rem solid var(--color-globalstate-hover-border)}.sol-text-area .sol-text-area-input:active,.sol-text-area .sol-text-area-input:focus{border:.0625rem solid var(--color-globalstate-active-border)}.sol-text-area .sol-text-area-input::placeholder{color:var(--color-globalstate-inactive-icon)}.sol-text-area .sol-text-area-input:read-only{border:.0625rem solid var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background)}.sol-text-area .sol-text-area-input:read-only::placeholder{color:var(--global-state-active-content)}.sol-text-area .sol-text-area-input:disabled{border:.0625rem solid var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background)}.sol-text-area .sol-text-area-input:disabled::placeholder{color:var(--color-globalstate-disabled-content)}.sol-text-area .sol-text-area-input.resize-textarea{resize:auto}.sol-text-area .sol-text-area-input.font-size-small{font-size:var(--typography-opensans-body-body3-font-size);line-height:var(--typography-opensans-body-body3-line-height)}.sol-text-area .sol-text-area-input.font-size-large{font-size:var(--typography-opensans-body-subtitle1-font-size);line-height:var(--typography-opensans-headline-h3-line-height);font-weight:var(--typography-opensans-body-body1-font-weight)}.sol-text-area .sol-text-area-input.hide-scroll{scrollbar-color:transparent transparent}.sol-text-area .sol-text-area-input.hide-scroll::-webkit-scrollbar-thumb{background-color:transparent}.sol-text-area .sol-text-area-input.hide-border{border-color:transparent}.sol-text-area .error-border{border:.0625rem solid var(--color-interface-error600)}.sol-text-area .error-border:active,.sol-text-area .error-border:focus,.sol-text-area .error-border:hover{border:.0625rem solid var(--color-interface-error600)}.sol-text-area .wrap-off{overflow-x:hidden}.sol-text-area .error-message{color:var(--color-interface-error600);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);text-transform:var(--typography-opensans-body-body4-text-case);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);font-stretch:var(--typography-opensans-body-body4-font-stretch);text-decoration:var(--typography-opensans-body-body4-text-decoration);display:block}.sol-text-area .error-message-container{min-height:1.25rem;margin-top:.4rem}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextAreaComponent, [{
    type: Component,
    args: [{
      selector: 'sol-text-area',
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: TextAreaComponent,
        multi: true
      }],
      template: "<div class=\"sol-text-area\">\n  <label\n    [class.label-disabled]=\"disabled\"\n    [class.read-only-label]=\"readonly\"\n    [attr.for]=\"id || defaultId\"\n    *ngIf=\"labelText\"\n    [attr.aria-label]=\"ariaLabel || null\"\n  >\n    {{ labelText }}\n    <span *ngIf=\"required && !disabled\" class=\"required-label\">*</span>\n  </label>\n  <textarea\n    [attr.name]=\"name\"\n    [id]=\"id || defaultId\"\n    [class]=\"textareaFontSizeClass\"\n    [class.error-border]=\"errorMessageText || errorState\"\n    [class.read-only]=\"readonly\"\n    [class.disabled]=\"disabled\"\n    [class.resize-textarea]=\"resizeTextarea\"\n    [class.wrap-off]=\"wrap === 'off'\"\n    class=\"sol-text-area-input\"\n    [class.hide-border]=\"hideBorder\"\n    [class.hide-scroll]=\"overflowOrHidden()\"\n    [value]=\"value\"\n    [placeholder]=\"placeholder\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    [required]=\"required\"\n    [cols]=\"cols\"\n    [attr.name]=\"name\"\n    [cdkTextareaAutosize]=\"!resizeTextarea\"\n    #autosize=\"cdkTextareaAutosize\"\n    [cdkAutosizeMinRows]=\"minRows\"\n    [cdkAutosizeMaxRows]=\"maxRows\"\n    (input)=\"onInput($event)\"\n    (change)=\"onChange($event)\"\n    [attr.aria-labelledby]=\"ariaLabelledby\"\n    #textArea\n    [attr.minLength]=\"minlength\"\n    [attr.maxLength]=\"maxlength\"\n    [autocomplete]=\"autocomplete\"\n    [wrap]=\"wrap\"\n  >\n  </textarea>\n  <div class=\"error-message-container\" *ngIf=\"errorMessageText\">\n    <span class=\"error-message\">\n      {{ errorMessageText }}\n    </span>\n  </div>\n</div>\n",
      styles: [".sol-text-area{display:block}.sol-text-area label{font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-size:var(--typography-opensans-body-overline-font-size);line-height:var(--typography-opensans-headline-h6-line-height);letter-spacing:var(--typography-opensans-body-overline-letter-spacing);display:flex;align-items:center;text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-interface-text700);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-stretch:var(--typography-opensans-body-overline-font-stretch);flex:none;order:0;flex-grow:0;margin-bottom:.25rem}.sol-text-area label .required-label{color:var(--color-button-destructive-hover);padding-left:.25rem}.sol-text-area .read-only-label{color:var(--color-interface-text800)}.sol-text-area .label-disabled{color:var(--color-globalstate-disabled-content)}.sol-text-area .sol-text-area-input{display:flex;padding:.5rem;border-radius:var(--radii-small-allcorners);border:.0625rem solid var(--global-state-inactive-border, #afc1ce);background:#fff;font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch);text-decoration:var(--typography-opensans-body-body3-text-decoration);color:var(--global-state-active-content);outline:none;box-sizing:content-box;max-width:calc(100% - 1.125rem)}.sol-text-area .sol-text-area-input:hover{border:.0625rem solid var(--color-globalstate-hover-border)}.sol-text-area .sol-text-area-input:active,.sol-text-area .sol-text-area-input:focus{border:.0625rem solid var(--color-globalstate-active-border)}.sol-text-area .sol-text-area-input::placeholder{color:var(--color-globalstate-inactive-icon)}.sol-text-area .sol-text-area-input:read-only{border:.0625rem solid var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background)}.sol-text-area .sol-text-area-input:read-only::placeholder{color:var(--global-state-active-content)}.sol-text-area .sol-text-area-input:disabled{border:.0625rem solid var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background)}.sol-text-area .sol-text-area-input:disabled::placeholder{color:var(--color-globalstate-disabled-content)}.sol-text-area .sol-text-area-input.resize-textarea{resize:auto}.sol-text-area .sol-text-area-input.font-size-small{font-size:var(--typography-opensans-body-body3-font-size);line-height:var(--typography-opensans-body-body3-line-height)}.sol-text-area .sol-text-area-input.font-size-large{font-size:var(--typography-opensans-body-subtitle1-font-size);line-height:var(--typography-opensans-headline-h3-line-height);font-weight:var(--typography-opensans-body-body1-font-weight)}.sol-text-area .sol-text-area-input.hide-scroll{scrollbar-color:transparent transparent}.sol-text-area .sol-text-area-input.hide-scroll::-webkit-scrollbar-thumb{background-color:transparent}.sol-text-area .sol-text-area-input.hide-border{border-color:transparent}.sol-text-area .error-border{border:.0625rem solid var(--color-interface-error600)}.sol-text-area .error-border:active,.sol-text-area .error-border:focus,.sol-text-area .error-border:hover{border:.0625rem solid var(--color-interface-error600)}.sol-text-area .wrap-off{overflow-x:hidden}.sol-text-area .error-message{color:var(--color-interface-error600);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);text-transform:var(--typography-opensans-body-body4-text-case);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);font-stretch:var(--typography-opensans-body-body4-font-stretch);text-decoration:var(--typography-opensans-body-body4-text-decoration);display:block}.sol-text-area .error-message-container{min-height:1.25rem;margin-top:.4rem}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }], {
    labelText: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    cols: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }],
    minlength: [{
      type: Input
    }],
    maxlength: [{
      type: Input
    }],
    minRows: [{
      type: Input
    }],
    maxRows: [{
      type: Input
    }],
    errorMessageText: [{
      type: Input
    }],
    errorState: [{
      type: Input
    }],
    autocomplete: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    resizeTextarea: [{
      type: Input
    }],
    fontSize: [{
      type: Input
    }],
    wrap: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input,
      args: ['aria-label']
    }],
    ariaLabelledby: [{
      type: Input,
      args: ['aria-labelledby']
    }],
    hideBorder: [{
      type: Input
    }],
    valueChange: [{
      type: Output
    }],
    textArea: [{
      type: ViewChild,
      args: ['textArea', {
        static: false
      }]
    }],
    focusOut: [{
      type: HostListener,
      args: ['focusout']
    }]
  });
})();
class TextAreaModule {
  static {
    this.ɵfac = function TextAreaModule_Factory(t) {
      return new (t || TextAreaModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TextAreaModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [TextFieldModule, CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextAreaModule, [{
    type: NgModule,
    args: [{
      imports: [TextFieldModule, CommonModule],
      declarations: [TextAreaComponent],
      exports: [TextAreaComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of text-area
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TextAreaComponent, TextAreaModule };
